/* gf-funnel (T-GUIDEFUNNEL): guide-funnel links ([data-gf-utm]) carry utm_source=meta&utm_medium=guide&utm_campaign=<guide> to the PDP,
   but only for visitors who reached the guide from the Comment GUIDE DM (landing URL has utm_medium=guide; remembered for the tab session).
   Search and other visitors keep plain PDP links, so internal links never overwrite their attribution (WS-BLOG C07). */
(function () {
  if (window.__gfFunnel) return;
  window.__gfFunnel = true;
  var KEY = 'plentum_gf_v1';
  function run() {
    var came = '';
    try {
      var q = new URLSearchParams(location.search);
      var med = (q.get('utm_medium') || '').toLowerCase();
      if (med === 'guide') sessionStorage.setItem(KEY, q.get('utm_campaign') || 'guide');
      else if (med) sessionStorage.removeItem(KEY); /* a later landing from another channel keeps its own attribution */
      came = sessionStorage.getItem(KEY) || '';
    } catch (e) { return; }
    if (!came) return;
    var links = document.querySelectorAll('a[data-gf-utm]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i], c = a.getAttribute('data-gf-utm');
      if (!c) continue;
      try {
        var u = new URL(a.getAttribute('href'), location.origin);
        u.searchParams.set('utm_source', 'meta');
        u.searchParams.set('utm_medium', 'guide');
        u.searchParams.set('utm_campaign', c);
        a.setAttribute('href', u.pathname + u.search + u.hash);
      } catch (e) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
